// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
// ── Dataset and dictionary ───────────────────────────────────────
export const PUBLIC_DATASET_STATUSES = ['draft', 'active', 'superseded', 'retired'];
export const DICTIONARY_VERSION_STATUSES = ['draft', 'confirmed', 'superseded'];
// ── Sharing ──────────────────────────────────────────────────────
export const SHARING_ARRANGEMENT_STATUSES = [
    'draft',
    'approved',
    'active',
    'under_review',
    'terminated',
];
export const SHARE_RECEIPT_STATUSES = ['pending', 'acknowledged', 'refused'];
// ── Open data release ────────────────────────────────────────────
export const RELEASE_READINESS_OUTCOMES = ['pending', 'cleared', 'blocked'];
export const OPEN_DATA_RELEASE_STATUSES = ['published', 'taken_down'];
// ── Quality and correction ───────────────────────────────────────
export const QUALITY_ISSUE_STATUSES = ['open', 'corrected', 'dismissed'];
export const CORRECTION_STATUSES = ['recorded', 'notifying', 'complete'];
// ── Collections ──────────────────────────────────────────────────
export const PUBLIC_DATASET_COLLECTION = 'grc_public_datasets';
export const PUBLIC_DATASET_DICTIONARY_COLLECTION = 'grc_public_dataset_dictionaries';
export const PUBLIC_DATA_ARRANGEMENT_COLLECTION = 'grc_public_data_arrangements';
export const PUBLIC_DATA_RECEIPT_COLLECTION = 'grc_public_data_receipts';
export const OPEN_DATA_READINESS_COLLECTION = 'grc_open_data_readiness';
export const OPEN_DATA_RELEASE_COLLECTION = 'grc_open_data_releases';
export const PUBLIC_DATA_QUALITY_ISSUE_COLLECTION = 'grc_public_data_quality_issues';
export const PUBLIC_DATA_CORRECTION_COLLECTION = 'grc_public_data_corrections';
//# sourceMappingURL=public-data.js.map